/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, { useContext, useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import useTypedSelector from "@Services/Hooks/UseTypedSelector";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";

import ApplicationApiContext from "@Contexts/Api";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import { Button, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";

import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";
import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";

import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import { Row } from "react-bootstrap";
import { APPLICATION_ROUTER_INTERFACE } from "@DATA/Router/Interfaces/Router";
import { ApplicationRouterContext } from "@Contexts/Router";
import { BHPCOURSE_INTERFACE } from "@Services/Application/Interfaces/Users/User";
import { BHPCOURSE_QUIZ_ANSWERS_INTERFACE } from "@Services/Application/Interfaces/Users/User";
import { BHPCOURSE_FINALIZATION_INTERFACE } from "@Services/Application/Interfaces/Users/User";

type BhpQuizFinalizationPageProps = { match?: any; location?: any; };

export const BhpQuizFinalizationPageComponent: React.FC<BhpQuizFinalizationPageProps> = ({
    match, location
}): JSX.Element | null => {

    const BHPCOURSE: BHPCOURSE_INTERFACE = location?.state?.bhpCourse;
    const ANSWERS: BHPCOURSE_QUIZ_ANSWERS_INTERFACE[] = location?.state?.answers ?? [];
    const TIMEEXPIRED: boolean = location?.state?.timeExpired ?? false;
    const TERMINAL_NO: string = location?.state.terminalNo;


    const DISPATCHER = useDispatch();

    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    /** @const {object} INTERFACE_DATA - Application State Store Interface Data */
    const INTERFACE_DATA: ReturnType<any> = useTypedSelector(
        (state) => state.interface
    );

    /** @const {boolean} REST_API_REQUEST_STATUS - Application Global State Rest Api Request Status */
    const REST_API_REQUEST_STATUS: boolean = INTERFACE_DATA?.apiRequestStatus || false;

    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA: ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;

    const [BHPCURSE_FINALIZATION, SET_BHPCOURSE_FINALIZATION] = useState<BHPCOURSE_FINALIZATION_INTERFACE | null>(null)
    const [BHPCOURSE_ERROR, SET_BHPCOURSE_RESPONSE_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);

    useEffect(() => {

        const GET_BHPCOURSE_FINALIZATION = async (): Promise<void> => {

            if (!REST_API_URL) return;

            const BHPCOURSE_API_URL = REST_API_URL + "/Terminal/Quiz/Finalization";

            const BHPCOURSE_FINALIZATION_REQUEST_DATA = {
                UserId: LOGGED_USER?.userID,
                QuizNo: BHPCOURSE.QuizNo,
                Questions: ANSWERS
            };

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

            try {

                const BHPCOURSE_FINALIZATION_RESPONSE = await REST_API_REQUEST(
                    BHPCOURSE_API_URL,
                    BHPCOURSE_FINALIZATION_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (BHPCOURSE_FINALIZATION_RESPONSE.status === 200) {

                    const CONTENT: any = await BHPCOURSE_FINALIZATION_RESPONSE.json();
                    SET_BHPCOURSE_FINALIZATION(CONTENT);

                } else {
                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await BHPCOURSE_FINALIZATION_RESPONSE.json();
                    SET_BHPCOURSE_RESPONSE_ERROR({ ErrorCode: BHPCOURSE_FINALIZATION_RESPONSE.status, UserMessage: CONTENT.UserMessage });
                }

            } catch (e) {
                SET_BHPCOURSE_RESPONSE_ERROR({ ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK" });
            }

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        };

        if (!TIMEEXPIRED) {
            GET_BHPCOURSE_FINALIZATION();
        }
        else {
            SET_BHPCOURSE_RESPONSE_ERROR({ ErrorCode: 500, UserMessage: "Upłynął czas przeznaczony na udzielenie odpowiedzi." })
        }

    }, []);

    useEffect(() => {
        return () => {
            SET_BHPCOURSE_FINALIZATION(null);
            SET_BHPCOURSE_RESPONSE_ERROR(null);
        };
    }, []);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;

    return (
        <BlockContentContainerComponent cssClasses={"settings-page-user-data-component settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Szkolenie BHP"} />

            {!!BHPCOURSE_ERROR ?

                <div style={{ height: "64vh", width: "100%" }}>
                    <ErrorMessageComponent messageText={BHPCOURSE_ERROR.UserMessage} />
                </div>

                :

                !!BHPCURSE_FINALIZATION ?

                    <Col xs={12} className={"user-profile-data user-information-data"}>
                        <Row className={"user-profile-data-content"}>

                            <Col xs={12} className={"user-information-section-component user-information-section user-document-data"} style={{ minHeight: "64vh" }}>
                                <Row className={"user-information-section-content"}>
                                    <Col xs={12} className={"user-information-data user-important-information user-name"}>
                                        {BHPCURSE_FINALIZATION.Result == 1 ?
                                            <span>GRATULACJE<br />Szkolenie zaliczone</span>
                                            :
                                            <span>NIESTETY<br />Szkolenie nie zaliczone</span>
                                        }
                                    </Col>

                                    <Col xs={12} className={"user-information-data"} style={{ marginTop: 40, marginBottom: 40 }}>
                                        <span>{BHPCURSE_FINALIZATION.FinalizationText}</span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>

                    :

                    !REST_API_REQUEST_STATUS &&
                    <Col xs={12} className={"no-list-elements-message default-system-message"}>
                        <span>{`Czekam na odpowiedz z serwera`}</span>
                    </Col>
            }
            <Col xs={12} style={{ marginTop: 30, marginBottom: 80, textAlign: "center" }}>
                {BHPCURSE_FINALIZATION?.Result == 1 ?
                    <></>
                    :
                    <NavLink to={{ pathname: ROUTER.AUTHENTICATED.SETTINGS.SETTINGS_MY_BHP_PAGE.QUIZ.QUIZDESC.URL, state:{terminalNo: TERMINAL_NO} }} title={"Ponów"} style={{ marginLeft: 5 }}>
                        <Button size={"sm"}>
                            <span>{`Ponów`}</span>
                        </Button>
                    </NavLink>
                }

                <NavLink to={{ pathname: ROUTER.AUTHENTICATED.SETTINGS.MAIN_PAGE.URL }} title={"Zakończ"} style={{ marginLeft: 5 }}>
                    <Button size={"sm"}>
                        <span>{`Zakończ`}</span>
                    </Button>
                </NavLink>
            </Col>

        </BlockContentContainerComponent>
    );

};


export default BhpQuizFinalizationPageComponent;
